// engine
import { ArController, gameDispatcher } from '@aceroll/core';

// hacksaw
import { responseService } from '@aceroll/platform-hacksaw';

import { platform } from '../../platform';

// constants
import { GAME_VIEW } from "../../constants/game";

// services
import { autoplayService } from '../../services/autoplay-service';
import { gameSoundService } from '../../services/game-sound-service';

export class EvFeatureEnter extends ArController {

	async onStart() {
		const serverEvent = responseService.getEvent();
		console.log('serverEvent', serverEvent);

		const { featureEnterPopup, healthBar } = this.context.currentLayout;

		platform.setFeatureTotalWin('0');

		const { name, count } = serverEvent.data;

		gameSoundService.fadeOutCurrentAmbient(1000);
		gameSoundService.setBonusSplashAmbient(500);

		platform.setFeatureEnter(name);

		let autoProceed = false;
		if (autoplayService.started && !autoplayService.stopAutoplayOnFeature) {
			autoProceed = true;
		}

		await featureEnterPopup.show(count, autoProceed);

		gameDispatcher.setState({
			gameType: name,
			gameView: GAME_VIEW.BONUS
		});

		gameSoundService.fadeOutCurrentAmbient(1000);
		// gameSoundService.setBonusAmbient(1500);

		await featureEnterPopup.hide();
		await healthBar.setHealth(count);
		gameSoundService.setBonusAmbient(1500);
		// Report that feature counter is being displayed
		platform.setFeatureCounter(count);

		responseService.completeEvent();
		this.stop();
	}
}
